import React from "react"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { OutlookSupportedLink, Link } from "./link.email"

export function Links({ id }) {
  const { children, properties } = useBlocks(id)

  const { fontSize, fontWeight, ...linkStyles } = properties

  return (
    <div className="ck-links-block">
      {/* Outlook-friendly version */}
      <outlook-only>
        <table
          border="0"
          cellPadding="0"
          cellSpacing="0"
          width="500px"
          style={{ borderCollapse: "collapse" }}
        >
          {children.map(link => (
            <OutlookSupportedLink
              key={link.block_id}
              styles={properties}
              {...link}
            />
          ))}
        </table>
      </outlook-only>

      {/* Modern version for other clients */}
      <except-outlook>
        <div style={{ fontSize: fontSize + "px", fontWeight }}>
          {children.map(link => (
            <Link key={link.block_id} styles={linkStyles} {...link} />
          ))}
        </div>
      </except-outlook>
    </div>
  )
}
